import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`;

export const fadeInDown = keyframes`
    0% {
      opacity: 0;
      transform: translate(0, -50px)
    }
    100% {
      opacity: 1;
    }
`;
